export const LeftIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='mask0_4_2893'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='6'
      y='4'
      width='8'
      height='12'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.9415 4.55806C13.1856 4.80214 13.1856 5.19786 12.9415 5.44194L8.38348 10L12.9415 14.5581C13.1856 14.8021 13.1856 15.1979 12.9415 15.4419C12.6975 15.686 12.3017 15.686 12.0577 15.4419L7.12836 10.5127C6.84523 10.2295 6.84523 9.77048 7.12836 9.48735L12.0577 4.55806C12.3017 4.31398 12.6975 4.31398 12.9415 4.55806Z'
        fill='black'
      />
    </mask>
    <g mask='url(#mask0_4_2893)'>
      <rect width='20' height='20' fill='#808080' />
    </g>
  </svg>
)
